export default __webpack_public_path__ + "static/media/icon-checkup-basico.9d85c4c7.svg";